module.exports = __webpack_public_path__ + "img/banner.20d79ab7.png";